import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import InputModal from './InputModal';
import { useIntl } from 'react-intl';
export default function CaptchaModal(param) {
    var isOpen = param.isOpen, description = param.description, onClose = param.onClose, onConfirm = param.onConfirm, title = param.title;
    var intl = useIntl();
    return /*#__PURE__*/ _jsx(InputModal, {
        isOpen: isOpen,
        title: title,
        onClose: onClose,
        description: description,
        validPredicate: function(token) {
            return token != null;
        },
        onSubmit: onConfirm,
        submitText: intl.formatMessage({
            id: "q5Xl0M",
            defaultMessage: [
                {
                    type: 0,
                    value: "Verify"
                }
            ]
        }),
        renderInput: function(param) {
            var setValue = param.setValue, setError = param.setError;
            return /*#__PURE__*/ _jsx(HCaptcha, {
                sitekey: process.env.HCAPTCHA_SITE_KEY,
                onError: function(err) {
                    return setError(err);
                },
                onVerify: function(token) {
                    return setValue(token);
                }
            });
        }
    });
}
